import { SvgIcon } from "@mui/material";

const ThreeDotVertIcon = (props) => {

    return (
        <SvgIcon viewBox="0 0 31 30" sx={{ ...props }}>
            <circle cx="15.5723" cy="15" r="15" fill="none" />
            <path
                d="M15.5703 15.625C15.9155 15.625 16.1953 15.3452 16.1953 15C16.1953 14.6548 15.9155 14.375 15.5703 14.375C15.2251 14.375 14.9453 14.6548 14.9453 15C14.9453 15.3452 15.2251 15.625 15.5703 15.625Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.5703 11.25C15.9155 11.25 16.1953 10.9702 16.1953 10.625C16.1953 10.2798 15.9155 10 15.5703 10C15.2251 10 14.9453 10.2798 14.9453 10.625C14.9453 10.9702 15.2251 11.25 15.5703 11.25Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.5703 19.999C15.9155 19.999 16.1953 19.7192 16.1953 19.374C16.1953 19.0288 15.9155 18.749 15.5703 18.749C15.2251 18.749 14.9453 19.0288 14.9453 19.374C14.9453 19.7192 15.2251 19.999 15.5703 19.999Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    )
}


export default ThreeDotVertIcon;